module.exports = __webpack_public_path__ + "static/img/view-01-main@m.941cac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket/view-01-main@m.jpg
// module id = HMK/
// module chunks = 0